import api from "../../index";

export const GetAllConfigurationApi = (params) => api.get(`Configuration/Get-All-Configuration?${params}`);
export const UpdateUserStatusApi = (data) => api.put('Configuration/Update-Configuration', data);
export const GetAllCommissionApi = (params) => api.get(`IBMaster/Get-Deal-Threshold-Data?${params}`);
export const AddUpdateAccountPrefixApi = (data) => api.put('Configuration/Add-Update-Account-Prefix', data);
